webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(124);


/***/ }),

/***/ 123:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var options = exports.options = {
	  legend: {
	    display: false
	  },
	  scales: {
	    yAxes: [{
	      stacked: true
	    }]
	  }
	};
	
	var backgroundColors = exports.backgroundColors = ['rgba(0, 158, 227, .5)', 'rgba(0, 136, 110, .5)', 'rgba(153, 13, 13, .5)', 'rgba(153, 13, 13, .5)'];
	
	var borderColors = exports.borderColors = ['rgba(0, 158, 227, 1)', 'rgba(0, 136, 110, 1)', 'rgba(153, 13, 13, 1)', 'rgba(153, 13, 13, 1)'];

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(122);
	
	var _ravenJs = __webpack_require__(120);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _LazyLoadFonts = __webpack_require__(126);
	
	var _LazyLoadFonts2 = _interopRequireDefault(_LazyLoadFonts);
	
	var _ToolTip = __webpack_require__(130);
	
	var _ToolTip2 = _interopRequireDefault(_ToolTip);
	
	var _YoutubeVideos = __webpack_require__(131);
	
	var _YoutubeVideos2 = _interopRequireDefault(_YoutubeVideos);
	
	var _Graphs = __webpack_require__(125);
	
	var _Graphs2 = _interopRequireDefault(_Graphs);
	
	var _ToggleMainNav = __webpack_require__(129);
	
	var _ToggleMainNav2 = _interopRequireDefault(_ToggleMainNav);
	
	var _Share = __webpack_require__(127);
	
	var _Share2 = _interopRequireDefault(_Share);
	
	var _SmoothScroll = __webpack_require__(128);
	
	var _SmoothScroll2 = _interopRequireDefault(_SmoothScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function IIFE() {
	  if (true) {
	    _ravenJs2.default.config('https://127d5e40ea3d49b9b69659be2d60d066@sentry.io/147406').install();
	  }
	  (0, _LazyLoadFonts2.default)();
	  (0, _ToolTip2.default)();
	  (0, _YoutubeVideos2.default)();
	  (0, _ToggleMainNav2.default)();
	  (0, _Graphs2.default)();
	  (0, _Share2.default)();
	  (0, _SmoothScroll2.default)();
	})(); /**
	       * Main.js
	       *
	       * @since 1.0.0
	       */

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _chart = __webpack_require__(2);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _chart3 = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Graphs = function Graphs() {
	  var charts = document.querySelectorAll('.js-chart');
	  if (!charts.length) return;
	
	  [].concat(_toConsumableArray(charts)).forEach(function (chart) {
	    var _chart$dataset = chart.dataset,
	        type = _chart$dataset.type,
	        labels = _chart$dataset.labels,
	        data = _chart$dataset.data;
	
	    switch (type) {
	      case 'stacked':
	        stackedChart(chart, labels, data);
	        break;
	      case 'bar':
	        barChart(chart, labels, data);
	        break;
	      case 'double':
	        doubleChart(chart, labels, data);
	        break;
	    }
	  });
	};
	
	var doubleChart = function doubleChart(chart, labels, data) {
	  var canvas = chart.children[0] || false;
	  var backgrounds = ['#fd9726', '#2178cf'];
	  var datasets = data.split('|').map(function (set, i) {
	    var data = set.split(',').map(function (i) {
	      return parseInt(i, 10);
	    });
	    return { label: '', backgroundColor: backgrounds[i], data: data };
	  });
	  return new _chart2.default(canvas, {
	    type: 'bar',
	    options: { legend: { display: false }, scales: {} },
	    data: { labels: labels.split(','), datasets: datasets }
	  });
	};
	
	var barChart = function barChart(chart, labels, data) {
	  var canvas = chart.children[0] || false;
	  return new _chart2.default(canvas, {
	    type: 'bar',
	    options: {
	      legend: { display: false },
	      scales: { yAxes: [{ stacked: true }] }
	    },
	    data: {
	      labels: labels.split(','),
	      datasets: [{
	        label: '',
	        data: data.split(',').map(function (i) {
	          return parseInt(i, 10);
	        }),
	        backgroundColor: _chart3.backgroundColors[1]
	      }]
	    }
	  });
	};
	
	var stackedChart = function stackedChart(chart, labels, data) {
	  // Data is like this 12, 13, 14|15,12,13|etc..
	  var backgrounds = ['#378e46', '#fdc031', '#d12f35'];
	  var keys = data.split('|');
	  var canvas = chart.children[0] || false;
	  var datasets = keys.map(function (set, i) {
	    var data = set.split(',').map(function (item) {
	      return parseInt(item, 10);
	    });
	    return { label: '', data: data, backgroundColor: backgrounds[i], borderWidth: 1 };
	  });
	
	  return new _chart2.default(canvas, {
	    type: 'bar',
	    options: {
	      legend: { display: false },
	      scales: { xAxes: [{ stacked: true }], yAxes: [{ stacked: true }] }
	    },
	    data: { labels: labels.split(','), datasets: datasets }
	  });
	};
	
	exports.default = Graphs;
	
	
	_chart2.default.defaults.global.defaultFontColor = '#39404a';
	_chart2.default.defaults.global.defaultFontFamily = "'museo-sans', sans-serif";

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fontfaceobserver = __webpack_require__(4);
	
	var _fontfaceobserver2 = _interopRequireDefault(_fontfaceobserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LazyLoadFonts = function LazyLoadFonts() {
	  var font = new _fontfaceobserver2.default('museo-sans');
	  font.load().then(function () {
	    document.documentElement.classList.add('fonts-loaded');
	  });
	}; /**
	    * LazyLoad Fonts
	    *
	    * @since 1.0.0
	    */
	
	exports.default = LazyLoadFonts;

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Share
	 *
	 * @since 1.0.0
	 */
	
	var Share = function Share() {
	  var buttons = document.querySelectorAll('.js-share');
	  if (!buttons.length) return;
	
	  [].concat(_toConsumableArray(buttons)).forEach(function (button) {
	    button.addEventListener('click', function (e) {
	      e.preventDefault();
	
	      var type = this.dataset.type;
	
	      var href = window.location.href;
	
	      if (type === 'facebook') {
	        openWindow('https://www.facebook.com/sharer/sharer.php?u=' + href);
	      } else if (type === 'twitter') {
	        openWindow('http://twitter.com/share?url=' + href);
	      } else if (type === 'linkedin') {
	        openWindow('https://www.linkedin.com/shareArticle?mini=true&url=' + href);
	      }
	    });
	  });
	
	  var openWindow = function openWindow(url) {
	    window.open(url, '', 'width=450, height=250');
	  };
	};
	
	exports.default = Share;

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _smoothscroll = __webpack_require__(184);
	
	var _smoothscroll2 = _interopRequireDefault(_smoothscroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = function () {
	  var buttons = document.querySelectorAll('.js-smooth-scroll');
	  if (!buttons || buttons.length === 0) return;
	  [].concat(_toConsumableArray(buttons)).forEach(function (button) {
	    button.addEventListener('click', function (e) {
	      var target = button.dataset.target;
	
	      if (!target) return;
	      (0, _smoothscroll2.default)(document.getElementById(target).clientHeight, 500);
	      e.preventDefault();
	    });
	  });
	};

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Toggle Main nav
	 *
	 * @since 1.0.0
	 */
	
	var ToggleMainNav = function ToggleMainNav() {
	  var toggle = document.querySelector('.js-toggle-main-nav');
	  if (!toggle) return;
	
	  toggle.addEventListener('click', function () {
	    document.body.classList.toggle('has-active-main-nav');
	  });
	};
	
	exports.default = ToggleMainNav;

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Tooltip
	 *
	 * @since 1.0.0
	 */
	
	var ToolTip = function ToolTip() {
	  var tooltips = document.querySelectorAll('.js-tooltip');
	  if (!tooltips.length) return;
	  [].concat(_toConsumableArray(tooltips)).forEach(function (tooltip) {
	    tooltip.addEventListener('click', function () {
	      this.classList.toggle('c-tooltip--is-active');
	      var content = this.querySelector('.c-tooltip__content');
	      content.getAttribute('aria-hidden') === 'true' ? content.setAttribute('aria-hidden', 'false') : content.setAttribute('aria-hidden', 'true');
	    });
	  });
	};
	
	exports.default = ToolTip;

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Check a page for js-youtube-video elements and load them trough the Youtube API
	 *
	 * @since 1.0.0
	 */
	
	/* global YT */
	
	var youtubeVideos = document.querySelectorAll('.js-youtube-video');
	var playButtons = document.querySelectorAll('.js-play-youtube-video');
	var youtubePlayers = [];
	
	var YoutubeVideos = function YoutubeVideos() {
	  if (youtubeVideos.length) {
	    loadYoutubeApi();
	  }
	  if (playButtons.length) {
	    [].concat(_toConsumableArray(playButtons)).forEach(function (el) {
	      el.addEventListener('click', function () {
	        var videoContainer = el.getAttribute('data-video-container');
	        var iframeTarget = el.getAttribute('data-iframe-target');
	
	        addContainerPlayingState(videoContainer);
	        playVideo(iframeTarget);
	      });
	    });
	  }
	};
	
	function loadYoutubeApi() {
	  var tag = document.createElement('script');
	  tag.src = 'https://www.youtube.com/iframe_api';
	  var firstScriptTag = document.getElementsByTagName('script')[0];
	  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}
	
	window.onYouTubeIframeAPIReady = function () {
	  [].concat(_toConsumableArray(youtubeVideos)).forEach(function (el) {
	    var _el$dataset = el.dataset,
	        youtubeVideoId = _el$dataset.youtubeVideoId,
	        iframeId = _el$dataset.iframeId;
	
	    if (youtubeVideoId && iframeId) {
	      youtubePlayers.push({
	        iframeId: iframeId,
	        containerID: el.id,
	        player: createPlayer(iframeId, youtubeVideoId)
	      });
	    } else {
	      console.error('YoutubeID or iframeId is not set');
	    }
	  });
	};
	
	function createPlayer(containerID, youtubeVideoId) {
	  return new YT.Player(containerID, {
	    height: '390',
	    width: '640',
	    videoId: youtubeVideoId,
	    playerVars: {
	      rel: 0,
	      showinfo: 0,
	      autohide: 1,
	      playsinline: 1,
	      html5: 1,
	      modestbranding: 1
	    },
	    events: { onStateChange: onPlayerStateChange }
	  });
	}
	
	function onPlayerStateChange(e) {
	  // Test if player is finished
	  if (e.data === 0) {
	    e.target.a.offsetParent.classList.remove('c-video--playing');
	  }
	}
	
	function addContainerPlayingState(container) {
	  pauseAllPlayers();
	  document.getElementById(container).classList.add('c-video--playing');
	}
	
	function pauseAllPlayers() {
	  [].concat(youtubePlayers).forEach(function (el) {
	    if (el.player.pauseVideo) {
	      el.player.pauseVideo();
	    }
	  });
	}
	
	function playVideo(iframeID) {
	  [].concat(youtubePlayers).forEach(function (el) {
	    if (el.iframeID === iframeID) {
	      el.player.playVideo();
	    }
	  });
	}
	
	exports.default = YoutubeVideos;

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, smoothScroll) {
	  'use strict';
	
	  // Support RequireJS and CommonJS/NodeJS module formats.
	  // Attach smoothScroll to the `window` when executed as a <script>.
	
	  // RequireJS
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (smoothScroll), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // CommonJS
	  } else if (typeof exports === 'object' && typeof module === 'object') {
	    module.exports = smoothScroll();
	
	  } else {
	    root.smoothScroll = smoothScroll();
	  }
	
	})(this, function(){
	'use strict';
	
	// Do not initialize smoothScroll when running server side, handle it in client:
	if (typeof window !== 'object') return;
	
	// We do not want this script to be applied in browsers that do not support those
	// That means no smoothscroll on IE9 and below.
	if(document.querySelectorAll === void 0 || window.pageYOffset === void 0 || history.pushState === void 0) { return; }
	
	// Get the top position of an element in the document
	var getTop = function(element, start) {
	    // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
	    if(element.nodeName === 'HTML') return -start
	    return element.getBoundingClientRect().top + start
	}
	// ease in out function thanks to:
	// http://blog.greweb.fr/2012/02/bezier-curve-based-easing-functions-from-concept-to-implementation/
	var easeInOutCubic = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
	
	// calculate the scroll position we should be in
	// given the start and end point of the scroll
	// the time elapsed from the beginning of the scroll
	// and the total duration of the scroll (default 500ms)
	var position = function(start, end, elapsed, duration) {
	    if (elapsed > duration) return end;
	    return start + (end - start) * easeInOutCubic(elapsed / duration); // <-- you can change the easing funtion there
	    // return start + (end - start) * (elapsed / duration); // <-- this would give a linear scroll
	}
	
	// we use requestAnimationFrame to be called by the browser before every repaint
	// if the first argument is an element then scroll to the top of this element
	// if the first argument is numeric then scroll to this location
	// if the callback exist, it is called when the scrolling is finished
	// if context is set then scroll that element, else scroll window
	var smoothScroll = function(el, duration, callback, context){
	    duration = duration || 500;
	    context = context || window;
	    var start = context.scrollTop || window.pageYOffset;
	
	    if (typeof el === 'number') {
	      var end = parseInt(el);
	    } else {
	      var end = getTop(el, start);
	    }
	
	    var clock = Date.now();
	    var requestAnimationFrame = window.requestAnimationFrame ||
	        window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
	        function(fn){window.setTimeout(fn, 15);};
	
	    var step = function(){
	        var elapsed = Date.now() - clock;
	        if (context !== window) {
	          context.scrollTop = position(start, end, elapsed, duration);
	        }
	        else {
	          window.scroll(0, position(start, end, elapsed, duration));
	        }
	
	        if (elapsed > duration) {
	            if (typeof callback === 'function') {
	                callback(el);
	            }
	        } else {
	            requestAnimationFrame(step);
	        }
	    }
	    step();
	}
	
	var linkHandler = function(ev) {
	    ev.preventDefault();
	
	    if (location.hash !== this.hash) window.history.pushState(null, null, this.hash)
	    // using the history api to solve issue #1 - back doesn't work
	    // most browser don't update :target when the history api is used:
	    // THIS IS A BUG FROM THE BROWSERS.
	    // change the scrolling duration in this call
	    var node = document.getElementById(this.hash.substring(1))
	    if(!node) return; // Do not scroll to non-existing node
	
	    smoothScroll(node, 500, function(el) {
	        location.replace('#' + el.id)
	        // this will cause the :target to be activated.
	    });
	}
	
	// We look for all the internal links in the documents and attach the smoothscroll function
	document.addEventListener("DOMContentLoaded", function () {
	    var internal = document.querySelectorAll('a[href^="#"]:not([href="#"])'), a;
	    for(var i=internal.length; a=internal[--i];){
	        a.addEventListener("click", linkHandler, false);
	    }
	});
	
	// return smoothscroll API
	return smoothScroll;
	
	});


/***/ })

});


// WEBPACK FOOTER //
// /main.f8d75269191a84d6000a.js